export interface ArtifactTemplate {
  id: string;
  title: string;
  subtitle: string;
  prompt: string;
  image?: string; // Optional custom image path - falls back to default illustration if not provided
}

export const artifactTemplates: ArtifactTemplate[] = [
  {
    id: 'workflow-rules-migration',
    title: 'Workflow Rules Migration Plan',
    subtitle: 'Plan your migration from Workflow Rules to Flows.',
    image: undefined, // TODO: Add custom image when available
    prompt:
      'Create an artifact for Workflow Rules migration plan for my org. Identify all objects with Workflow Rules, ranked by rule count. For each object, list all Workflow Rules with: rule name, evaluation criteria, actions performed (email alerts, field updates, tasks, outbound messages), and complexity score (simple/medium/complex). Group rules by migration priority (high/medium/low) based on complexity and business impact. Include a migration roadmap with: total rules to migrate, estimated effort per group, recommended migration order, and potential consolidation opportunities. Add visual charts showing rule distribution by object and complexity breakdown.',
  },
  {
    id: 'process-builder-analysis',
    title: 'Process Builder Analysis',
    subtitle:
      'Analyze and document all Process Builder automations in your Salesforce org for migration planning.',
    image: undefined,
    prompt:
      'Create an artifact analyzing all Process Builder automations in my org. List each process with: name, object, trigger conditions, number of action groups, and actions performed. Identify processes that can be consolidated or migrated to Flows. Highlight any processes with performance concerns (too many criteria nodes, recursive triggers). Provide recommendations for optimization and migration priority. Additionally, create a detailed migration timeline with phases, dependencies between processes, rollback procedures, and testing requirements. Include stakeholder communication templates and training materials for the transition. Document all edge cases and exception handling that needs to be preserved during migration.',
  },
  {
    id: 'validation-rules-audit',
    title: 'Comprehensive Validation Rules Audit and Analysis Report',
    subtitle: 'Comprehensive audit of all validation rules.',
    image: undefined,
    prompt:
      'Create an artifact auditing all validation rules across my org. For each object, list validation rules with: rule name, active status, error condition formula, error message, and error location. Identify potentially conflicting rules, overly complex formulas, and rules that may cause user friction. Provide recommendations for consolidation and improvement.',
  },
  {
    id: 'field-usage-analysis',
    title: 'Field Usage Analysis',
    subtitle: 'Analyze field usage and identify unused fields.',
    image: undefined,
    prompt:
      'Create an artifact analyzing field usage across my org. For key objects (Account, Contact, Opportunity, Lead, Case), identify: fields with no data, fields with low population rates, duplicate or redundant fields, and fields not used in any automation, report, or page layout. Provide recommendations for field cleanup and data quality improvement.',
  },
  {
    id: 'automation-inventory',
    title: 'Automation Inventory',
    subtitle: 'Complete inventory of all automations in your org.',
    image: undefined,
    prompt:
      'Create an artifact with a complete inventory of all automations in my org. Include: Flows (by type), Process Builders, Workflow Rules, Apex Triggers, and Scheduled Jobs. For each, show: name, object, trigger type, last modified date, and status. Identify overlapping automations on the same object and potential conflicts. Create a summary dashboard showing automation distribution by type and object.',
  },
  {
    id: 'permission-set-review',
    title: 'Permission Set Review',
    subtitle: 'Review and optimize permission set assignments.',
    image: undefined,
    prompt:
      'Create an artifact reviewing all permission sets in my org. List each permission set with: name, description, number of users assigned, key permissions granted, and license type required. Identify permission sets with overlapping permissions, unused permission sets, and users with excessive permissions. Provide recommendations for consolidation and security improvement.',
  },
  {
    id: 'report-and-dashboard-cleanup',
    title: 'Report & Dashboard Cleanup',
    subtitle: 'Identify unused reports and dashboards for cleanup.',
    image: undefined,
    prompt:
      'Create an artifact identifying reports and dashboards for cleanup in my org. Find: reports not run in the last 6 months, dashboards not viewed recently, reports owned by inactive users, and duplicate or similar reports. Provide a cleanup plan with estimated storage savings and recommendations for report folder organization.',
  },
  {
    id: 'apex-code-health',
    title: 'Apex Code Health Check',
    subtitle: 'Assess the health and quality of Apex code.',
    image: undefined,
    prompt:
      'Create an artifact assessing Apex code health in my org. Analyze: test coverage by class, classes with no tests, triggers without handler patterns, hardcoded IDs or credentials, SOQL queries in loops, and deprecated API usage. Provide a code health score and prioritized recommendations for improvement.',
  },
  {
    id: 'integration-mapping',
    title: 'Integration Mapping',
    subtitle: 'Map all external integrations and connected apps.',
    image: undefined,
    prompt:
      'Create an artifact mapping all integrations in my org. Include: Connected Apps, Named Credentials, External Services, Outbound Messages, and Platform Events. For each integration, document: name, purpose, authentication method, endpoints used, and data flow direction. Identify unused integrations and security concerns. Create a visual integration architecture diagram.',
  },
];
